import { createSlice } from "@reduxjs/toolkit";

// Define the initial state for the theme mode, defaulting to 'dark'.
const initialState = {
  mode: "dark",
};

// Create a slice for mode state with a name, initial state, and reducers to handle actions.
const modeSlice = createSlice({
  name: "mode", // The slice's name.
  initialState,
  // Reducers to handle actions; here we have a single toggle action.
  reducers: {
    // Toggle the mode between 'light' and 'dark'.
    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    },
  },
});

// Export the generated action creators and the reducer.
export const { setMode } = modeSlice.actions;
export const modeReducer = modeSlice.reducer;
